export default "__VITE_ASSET__VDtEWWrW__"